<div class="d-flex justify-content-end align-items-start">
  <button class="btn setting-btn edit-group-export-btn" (click)="export(exportValue)" [disabled]="isExportLoading">
    <loading-spinner *ngIf="isExportLoading"></loading-spinner>
    <span *ngIf="!isExportLoading">
      {{label}}
    </span>
  </button>
  <div class="dd-menu">
    <auto-group-filter-box 
      [options]="exportOptions" 
      [(model)]="exportValue"
      placeholder="{{'new_group_settings.dropdown_placeholder' | translate}}" 
      [multiple]="false"
      name="export_influencer_{{componentId}}" 
      class="w-25"
    >
    </auto-group-filter-box>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/export-influencer/export-influencer.component.html